var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2077 9.29379C16.4555 9.29379 18.3895 7.24745 18.3895 4.58295C18.3895 1.95042 16.445 0 14.2077 0C11.9809 0 10.0259 1.99305 10.0364 4.60426C10.0364 7.24745 11.9705 9.29379 14.2077 9.29379ZM14.2077 11.2016C12.42 11.2016 10.8623 11.6279 9.59727 12.2887C11.1027 13.5463 12.0645 15.4541 12.0645 17.5857C12.0645 18.1186 12.0018 18.6622 11.8764 19.1631H20.7732C22.4145 19.1631 23 18.6835 23 17.7456C23 14.9958 19.6232 11.2016 14.2077 11.2016ZM5.31091 23C8.19636 23 10.6218 20.538 10.6218 17.5857C10.6218 14.6121 8.22773 12.1715 5.31091 12.1715C2.40455 12.1715 0 14.6121 0 17.5857C0 20.5593 2.40455 23 5.31091 23ZM5.32136 21.1029C4.95545 21.1029 4.63136 20.8471 4.63136 20.4421V18.2359H2.63455C2.27909 18.2359 1.98636 17.9374 1.98636 17.5857C1.98636 17.2234 2.27909 16.9249 2.63455 16.9249H4.63136V14.7187C4.63136 14.3137 4.95545 14.0686 5.32136 14.0686C5.67682 14.0686 6.00091 14.3137 6.00091 14.7187V16.9249H7.99773C8.35318 16.9249 8.63545 17.2234 8.63545 17.5857C8.63545 17.9374 8.35318 18.2359 7.99773 18.2359H6.00091V20.4421C6.00091 20.8471 5.67682 21.1029 5.32136 21.1029Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-share.703821d8ef3570726d88b09ca265373d.svg";